import React from "react"
import Apart1Provider from "./ApartContext_1"
import Apart2Provider from "./ApartContext_2"
import Apart3Provider from "./ApartContext_3"
import Apart4Provider from "./ApartContext_4"
import Apart5Provider from "./ApartContext_5"
import Apart6Provider from "./ApartContext_6"
import Apart7Provider from "./ApartContext_7"
import Apart8Provider from "./ApartContext_8"
import Apart9Provider from "./ApartContext_9"
import Apart10Provider from "./ApartContext_10"
import Apart11Provider from "./ApartContext_11"
import Apart12Provider from "./ApartContext_12"
import Apart13Provider from "./ApartContext_13"
import Apart14Provider from "./ApartContext_14"
import Apart15Provider from "./ApartContext_15"
import Apart16Provider from "./ApartContext_16"
import Apart17Provider from "./ApartContext_17"
import Apart18Provider from "./ApartContext_18"
import Apart19Provider from "./ApartContext_19"

/**
 * Wrapper component that provides all apartment contexts to the application
 * This allows any component to access any apartment data through the respective context hooks
 */
export const ApartmentContextProvider = ({ children }) => {
  return (
    <Apart1Provider>
      <Apart2Provider>
        <Apart3Provider>
          <Apart4Provider>
            <Apart5Provider>
              <Apart6Provider>
                <Apart7Provider>
                  <Apart8Provider>
                    <Apart9Provider>
                      <Apart10Provider>
                        <Apart11Provider>
                          <Apart12Provider>
                            <Apart13Provider>
                              <Apart14Provider>
                                <Apart15Provider>
                                  <Apart16Provider>
                                    <Apart17Provider>
                                      <Apart18Provider>
                                        <Apart19Provider>
                                          {children}
                                        </Apart19Provider>
                                      </Apart18Provider>
                                    </Apart17Provider>
                                  </Apart16Provider>
                                </Apart15Provider>
                              </Apart14Provider>
                            </Apart13Provider>
                          </Apart12Provider>
                        </Apart11Provider>
                      </Apart10Provider>
                    </Apart9Provider>
                  </Apart8Provider>
                </Apart7Provider>
              </Apart6Provider>
            </Apart5Provider>
          </Apart4Provider>
        </Apart3Provider>
      </Apart2Provider>
    </Apart1Provider>
  )
}

export default ApartmentContextProvider
